export const STATUS_LOCKED = 'L';
export const STATUS_RESERVED = 'R';
export const STATUS_PROTECTED = 'P';
export const STATUS_AVAILABLE = 'A';
export const STATUS_CARTED = 'C';
export const STATUS_REQUESTING = 'Q';
export const STATUS_RELEASING = 'S';
